<template>
    <div>
      <van-row justify="space-around">
        <van-col span="18">
          <van-row>
            <van-col span="6">
              <div class="logo">
                <img  :src="logo">
              </div>

            </van-col>
            <van-col span="18">
              <div class="toptitle"> {{getTimeState()}}
                 </div>
              <div class="topdesc"> 想要赚多多，就用优推联盟</div>

            </van-col>

          </van-row>
        </van-col>
        <van-col span="6">

        </van-col>
      </van-row>

        <div class="header">
            <div style="height: 175px;position:relative">
                <div @click="changePlayStatus"
                     style="z-index: 1;position:absolute;right: 0;bottom: 0;width: 40px;height: 40px">
                    <!--外面套一层40*40，增大点击范围，比较容易点到-->
                    <van-icon :name="playIcon" style="position:absolute;right: 10px;bottom: 10px"></van-icon>
                </div>
                <!--<div v-if="!showFlag&&images.length>0">-->
                <div v-if="images.length>0">
                    <van-swipe :autoplay="autoplay" @change="onChange">
                        <van-swipe-item v-for="(image, index) in images" :key="index">
                            <a :href="image.redirectUrl" v-if="image.redirectUrl">
                                <img :src="image.imgUrl" class="swipe_item"/>
                            </a>
                            <img :src="image.imgUrl" class="swipe_item" v-else/>
                        </van-swipe-item>
                    </van-swipe>
                </div>

            </div>

            <div class="column">
                <van-row>
                    <van-col span="6">
                        <router-link :to="{path:sliderObj.categoryUrl1}">
                            <img :src="sliderObj.categoryIcon1">
                            <p>{{sliderObj.categoryText1}}</p>
                        </router-link>
                    </van-col>
                    <van-col span="6">
                        <router-link :to="{path:sliderObj.categoryUrl2}">
                            <img :src="sliderObj.categoryIcon2">
                            <p>{{sliderObj.categoryText2}}</p>
                        </router-link>
                    </van-col>
                    <van-col span="6">
                       <router-link :to="{path:sliderObj.categoryUrl3}">
                            <img :src="sliderObj.categoryIcon3">
                            <p>{{sliderObj.categoryText3}}</p>
                        </router-link>
                    </van-col>
                    <van-col span="6">
                        <router-link :to="{path:sliderObj.categoryUrl4}">
                            <img :src="sliderObj.categoryIcon4">
                            <p>{{sliderObj.categoryText4}}</p>
                        </router-link>
                    </van-col>
                </van-row>
                <van-row>
                    <van-col span="6">
                       <router-link :to="{path:sliderObj.categoryUrl5}">
                            <img :src="sliderObj.categoryIcon5">
                            <p>{{sliderObj.categoryText5}}</p>
                        </router-link>
                    </van-col>
                    <van-col span="6">
                        <router-link :to="{path:sliderObj.categoryUrl6}">
                            <img :src="sliderObj.categoryIcon6">
                            <p>{{sliderObj.categoryText6}}</p>
                        </router-link>
                    </van-col>
                    <van-col span="6">
                        <router-link :to="{path:sliderObj.categoryUrl7}">
                            <img :src="sliderObj.categoryIcon7">
                            <p>{{sliderObj.categoryText7}}</p>
                        </router-link>
                    </van-col>
                    <van-col span="6">
                       <router-link :to="{path:sliderObj.categoryUrl8}">
                            <img :src="sliderObj.categoryIcon8">
                            <p>{{sliderObj.categoryText8}}</p>
                        </router-link>
                    </van-col>
                </van-row>
            </div>

            <div class="column">
              <van-row style="text-align:left;">
                最新消息
              </van-row>
              <van-row>
                <a :href="sliderObj.messageUrl1">
                  <p class="messageText">{{sliderObj.messageText1}}</p>
                </a>
              </van-row>
              <van-row>
                <a :href="sliderObj.messageUrl2">
                  <p class="messageText">{{sliderObj.messageText2}}</p>
                </a>
              </van-row>
              <van-row>
                <a :href="sliderObj.messageUrl3">
                  <p class="messageText">{{sliderObj.messageText3}}</p>
                </a>
              </van-row>
            </div>
          <p class="showP">任务推广<span>给自己加薪</span></p>

            <van-popup v-model="show"
            closeable
            class="dialog-test"
            close-icon="close"
            close-icon-position="top-right"
            :style="{ width: '75%' }">
              <div class="dialog-content">
                <img :src="noticeImg" width="100%"/>
             </div>
            </van-popup>




        </div>

        <div class="bottom">
            <div v-for="task in mainTaskList" :key="task.id" class="task">

              <van-row @click="queryTaskShare(task.id)">
                <van-col span="8">
                  <div class="tasklogo">
                    <img  @click="queryTaskShare(task.id)" :src="task.jobExInfo.logoUrl" style="width: 100%"/>
                  </div>

                </van-col>
                <van-col span="16">
                  <van-row>
                    <div class="tasktitle" @click="queryTaskShare(task.id)" > {{task.name}}</div>
                  </van-row>

                  <van-row justify="space-around">
                    <van-col span="18">
                      <van-row>
                        {{task.ruleDesc}}
                      </van-row>
                    </van-col>
                    <van-col span="6" style="text-align:right">

                    </van-col>
                  </van-row>

                  <van-row class="line">
                    <van-col span="24" class="commission">单价</van-col>
                    <van-col span="12" v-for="(value,index) in task.jobItemJoinPriceList" :key="index"
                             style="padding-top: 0;">
                      {{value.name}}：<span class="commission" v-if="value.extendsPriceRMB">{{value.extendsPriceRMB}}{{value.mode === 1 ? '%' : ''}}</span>
                    </van-col>
                  </van-row>



                  <van-row>
                    <van-col span="16" class="tag">
                      <van-row>
                        <van-col span="6" v-for="tag in task.tags" :key="tag" style="padding:0 2.5px 0 0">
                          <span> {{tag}}</span>
                        </van-col>
                      </van-row>
                    </van-col>
                    <van-col span="8" class="signCount">
                      <div style="display: flex;justify-content:flex-end;margin-top:0.45rem">
                        <div style="margin-right:5px"><img :src="tuandui"></div>
                        <div>已报名:{{task.count!=null?task.count:'&nbsp;&nbsp;&nbsp;'}}</div>
                      </div>
                    </van-col>
                  </van-row>
                </van-col>
              </van-row>
              <van-row class="item-bottom">
                <van-col span="12">
                  <div style="text-align: center"   @click="setprice(task.id)">
                    <van-icon name="records" /> 统一设价
                  </div>

                </van-col>
                <van-col span="12">
                  <div style="text-align: center;border-left: 2px solid #e2e2e2;"    @click="queryTaskShare(task.id)">
                    <van-icon name="guide-o" />  {{task.traderId?'查看分享':'立即报名'}}
                  </div>
                </van-col>

              </van-row>

            </div>

            <div class="remarks">即刻加入联盟，领取更多高收益任务......</div>
            
        </div>
        
    </div>

</template>

<script>
    import Vue from 'vue'
    import renwu from '@/assets/images/m01.png'
    import zuji from '@/assets/images/m02.png'
    import zhuanyongjin from '@/assets/images/m03.png'
    import jiujiu from '@/assets/images/m04.png'
    import xinyongka from '@/assets/images/m05.png'
    import duihuan from '@/assets/images/m06.png'
    import lingjuan from '@/assets/images/m07.png'
    import daxue from '@/assets/images/m08.png'
    import qbj from '@/assets/images/m09.png'
    import fuzhu from '@/assets/images/fuzhu.png'
    import huafei from '@/assets/images/huafei.png'
    import meituan from '@/assets/images/meituan.png'
    import meituanyouxuan from '@/assets/images/meituanyouxuan.png'
    import taote from '@/assets/images/taote.png'

    import choujin from '@/assets/images/choujin.png'
    import guanjun from '@/assets/images/guanjun.png'
    import wode from '@/assets/images/wode.png'
    import shouru from '@/assets/images/shouru.png'
    import tuijianzhishu from '@/assets/images/tuijianzhishu.png'
    import tuandui from '@/assets/images/tuandui.png'

    import ali from '@/assets/images/m_ali.png'
    import jd from '@/assets/images/m_jd.png'
    import diy from '@/assets/images/diy.png'
    import gyjh from '@/assets/images/gyjh.png'

    import jdpeiquan from '@/assets/images/jd_peiquan.png'

    import mainAPI from '@/api/main'
    import { Dialog } from 'vant'
    import logo from '@/assets/logo.jpg'

    export default {
        data() {
            return {
              logo:logo,
                choujin: choujin,
                guanjun: guanjun,
                daxue: daxue,
                wode: wode,
                renwu: renwu,
                shouru: shouru,
                tuijianzhishu: tuijianzhishu,
                tuandui: tuandui,
                xinyongka: xinyongka,
                duihuan: duihuan,
                lingjuan: lingjuan,
                jiujiu: jiujiu,
                qbj: qbj,
                fuzhu: fuzhu,
                huafei: huafei,
                meituan: meituan,
                meituanyouxuan: meituanyouxuan,
                taote: taote,
                zhuanyongjin: zhuanyongjin,
                zuji: zuji,
                ali: ali,
                jd: jd,
                diy: diy,
                gyjh: gyjh,
                jdpeiquan: jdpeiquan,
                showContent: {
                    historyRMB: '0.00', // 历史累计发放酬金
                    yesterdayRMB: '0.00', // 昨日累计发放酬金
                    yesterdayTop: {
                        name: '姓名', // 姓名
                        company: '店铺', // 公司名
                        incomeRMB: '0.00'// 收入
                    }
                },
                mainTaskList: [],
                images: [],
                showFlag: false,
                playStatus: true,
                playIcon: 'pause-circle-o',
                autoplay: 2000,
                showFlagTime: null,
                sliderObj:{},
                noticeImg:"",
                show: false,
            }
        },
        created() {
            this.queryMain()
        },
        methods: {
            onChange(index) {
                // if (index + 1 == this.images.length) {
                //     var t = setTimeout(() => {
                //         this.showFlag = true
                //         var time = setTimeout(() => {
                //             this.showFlag = false
                //         }, 4000)
                //     }, 2000)
                // }
                if (index === 0) {
                    this.showFlag = true
                    this.showFlagTime = setTimeout(() => {
                        this.showFlag = false
                    }, 2000)
                }
            },

            queryMain() {
                this.$toast.loading({forbidClick: true})
                mainAPI.index().then((result) => {
                    this.mainTaskList = result.data.mainTaskList
                    this.images = result.data.images
                    this.showContent = result.data.showContent;
                    this.sliderObj=result.data;
                    this.noticeImg=result.data.noticeImg;

                    if(this.noticeImg!=""){
                        if(Vue.config.isFirst){
                          this.show=true;
                          Vue.config.isFirst=false;
                       }
                        


                    }
                    this.$toast.clear()
                })
            },
            queryTaskShare(id) {
                this.$router.push('/main/task/share?id=' + id)
            },
            setprice(id){
                ///jobItemPrice?traderId=10078
                 this.$router.push('/user/jobItemPrice?action=setPrice&jobId=' + id)
            },
            changePlayStatus() {
                if (this.playStatus) {
                    this.playIcon = 'play-circle-o'
                    if (this.showFlag) { // 如果在统计页点暂停，就关掉定时器
                        clearTimeout(this.showFlagTime)
                    } else { // 在轮播图则关掉轮播时间
                        this.autoplay = 0
                    }
                } else {
                    this.playIcon = 'pause-circle-o'
                    if (this.showFlag) { // 如果在统计页点开始，就显示轮播图
                        this.showFlagTime = setTimeout(() => { // 缓冲一秒，比较自然
                            this.showFlag = false
                        }, 1000)
                    } else { // 在轮播图则开启轮播时间
                        this.autoplay = 2000
                    }
                }
                this.playStatus = !this.playStatus
            },
          getTimeState(){
            // 获取当前时间
            let timeNow = new Date();
            // 获取当前小时
            let hours = timeNow.getHours();
            // 设置默认文字
            let state= ``;
            // 判断当前时间段
            if (hours >= 0 && hours <= 10) {
              state = `早上好!`;
            } else if (hours > 10 && hours <= 14) {
              state= `中午好!`;
            } else if (hours > 14 && hours <= 18) {
              state= `下午好!`;
            } else if (hours > 18 && hours <= 24) {
              state= `晚上好!`;
            }
            return state;
          },

        }
    }
</script>

<style lang="scss" scoped>

    * {
        margin: 0;
        padding: 0;
    }

    .van-swipe{
      border-radius: 20px;
    }

    .swipe_item {
      height: 175px;
      width: 100%;
    }
    .item-bottom{
      background-color: #fafafa;
      color: #000000;
      div{
        color: #000000;
      }
    }
    .tasktitle{
      font-size: 1.5rem;
      font-weight: 600;
      color: #000000;
    }
    .tasklogo{
      margin: 1rem;
      border-radius: 1rem;
      overflow: hidden;
    }
    .toptitle{
      color: #000;
      margin-top: 1rem;
      font-size: 1.6rem;
      line-height: 2.8rem;

    }
    .topdesc{
      color: #8c8c8c;
      font-size: 1rem;
    }
    .taskimg{
      width: 100%;
      img{
        width: 100%;
      }
    }
    .logo{
      width: 5rem;
      height: 5rem;
      border-radius: 50%;
      overflow: hidden;
      margin: 0.6rem;
      background-color: #ff4218;
      img{
        width: 100%;
      }


    }

    .showContent {
        background: -webkit-linear-gradient(left top, coral, #ffbb5c); /* Safari 5.1 - 6.0 */
        background: -o-linear-gradient(bottom right, coral, #ffbb5c); /* Opera 11.1 - 12.0 */
        background: -moz-linear-gradient(bottom right, coral, #ffbb5c); /* Firefox 3.6 - 15 */
        background: linear-gradient(to bottom right, coral, #ffc987); /* 标准的语法 */
        padding: 2rem 1rem;

        ul {
            margin-left: 2rem;
            font-size: 1.3rem;
            color: #fff;

            span {
                font-size: 2.5rem;
            }
        }

        .van-row {
            margin: 1rem 0.5rem 0rem 0.5rem;
            font-size: 1.1rem;
            color: #fff;

            img {
                height: 1.5rem;
                width: 1.5rem;
            }

            span {
                font-size: 1.2rem;
                color: yellow;

            }

            .van-col {
                .spanTOP {
                    color: bisque;
                }
            }

        }
    }

    .column {
        text-align: center;
        background-color: #fff;
        margin-top: 0.5rem;
        padding: 1rem;

        .van-row {
            margin-bottom: 1rem;

            img {
                height: 4rem;
                width: 4rem;
            }

            p {
                font-size: 1.1rem;
                color: #8b8b8b;
            }

        }

    }

    .bottom {
      background-color: #fff;

      .task {
        padding: 1rem 1rem 0.5rem 1rem;
        margin: 0rem 1rem 1.5rem 1rem;

        -moz-box-shadow: 0 0 10px #e5e5e5;
        -webkit-box-shadow: 0 0 10px #e5e5e5;
        box-shadow: 0 0 10px #e5e5e5;
        border-radius: 1rem;

        .van-col {
          font-size: 1.1rem;
          color: #8b8b8b;
          padding-top: 1rem;
          padding-bottom: 0.5rem;

          .van-button {
            background-color: #ee822f;
            color: #fff;
          }

        }

        .line {
          border-bottom: 1px dashed #e5e5e5;
        }

        .tag span {
          text-align: center;
          font-size: 1rem;
          display: block;
          color: #fff;
          background-color: #ee822f;

          padding: 0.1rem 0rem;
        }

        .signCount {
          font-size: 1rem;
          color: #ee822f;

          img {
            height: 1.3rem;
            width: 1.2rem;
          }
        }

        .newUser {
          color: #3399ff;
        }

        .commission {
          color: #ee822f;
        }
      }

      .remarks {
        padding: 0rem 1rem 6rem 1rem;
        text-align: center;
        background-color: #fff;
        font-size: 1.2rem;
        color: #8b8b8b;
      }
    }

    .header {
      .showP {
        margin-top: 0.8rem;
        padding: 1.5rem 1.5rem;
        background-color: #FFFFFF;
        font-size: 1.5rem;
        font-weight: 600;
        span{
          font-size: 1.2rem;
          font-weight: 500;
          margin-left: 0.5rem;
        }
      }
    }

    .messageText {
      text-align: left;
      margin-left: 3rem;
      font-size: 1rem;
    }

</style>
